import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Tag from 'shopper/components/Tag/V1';

import Anchor from 'components/Anchor';
import CarouselBox from 'components/CarouselBox';

import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';

const MAX_TAGS_TO_SHOW_WITHOUT_ARROWS = 4;

const CategoriesCarousel = ({
  orderedCategories,
  gaEventCategory,
  className,
}) => {
  const { isMobile } = useMediaQuery();

  return (
    <CarouselBox
      arrowsProps={{
        className: 'flex',
        offsetX: { left: '-left-[15px]', right: '-right-[15px]' },
        type: 'primary',
      }}
      carouselProps={{
        className: 'py-4 w-full gap-4 [&>div]:flex-none',
      }}
      className={className}
      itemProps={{
        breakpoints: {
          md: { slidesPerView: 5 },
          lg: { slidesPerView: 12 },
          xl: { slidesPerView: 12 },
        },
        slidesPerView: 3,
        snapMode: 'snap-center',
      }}
      list={orderedCategories}
      render={({ id, name, href, active }) => (
        <NextLink key={id} href={href} prefetch={false} scroll={false} passHref>
          <Anchor
            className="flex items-center justify-center"
            onClick={() => {
              sendEvent({
                category: gaEventCategory,
                action: 'landing_category',
                value: name,
              });
            }}
          >
            <div>
              <Tag
                className={twJoin(
                  'mb-2 text-primary-300 dark:border-none dark:bg-primary-100',
                  active && 'dark:bg-primary-400 dark:text-primary-100'
                )}
                filled={active}
                size="size1"
                type="primary"
                clickable
              >
                {name}
              </Tag>
            </div>
          </Anchor>
        </NextLink>
      )}
      showArrows={
        !isMobile && orderedCategories.length >= MAX_TAGS_TO_SHOW_WITHOUT_ARROWS
      }
    />
  );
};

CategoriesCarousel.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  landingCategories: PropTypes.shape({
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        categoryId: PropTypes.number.isRequired,
        categoryName: PropTypes.string.isRequired,
        categorySlug: PropTypes.string.isRequired,
      })
    ),
    subcategories: PropTypes.arrayOf(
      PropTypes.shape({
        subcategoryId: PropTypes.number.isRequired,
        subcategoryName: PropTypes.string.isRequired,
        subcategorySlug: PropTypes.string.isRequired,
      })
    ),
  }),
};

export default CategoriesCarousel;
